import { Head } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { DiscordIcon, GoogleIcon } from "@/components/icons"

export default function Login() {
  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Head title="Login" />

      <Card className="w-full max-w-sm glow-border">
        <CardHeader className="text-center">
          <div className="scanlines inline-block">
            <CardTitle className="text-2xl font-mono glitch" data-text="BROKEN SOUNDS">BROKEN SOUNDS</CardTitle>
          </div>
          <CardDescription>Sign in to upload and download samples</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <form action="/auth/discord" method="post">
            <input type="hidden" name="authenticity_token" value={csrfToken} />
            <Button type="submit" variant="secondary" className="w-full gap-2">
              <DiscordIcon className="h-5 w-5" />
              Continue with Discord
            </Button>
          </form>

          <form action="/auth/google_oauth2" method="post">
            <input type="hidden" name="authenticity_token" value={csrfToken} />
            <Button type="submit" variant="secondary" className="w-full gap-2">
              <GoogleIcon className="h-5 w-5" />
              Continue with Google
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
